module.exports = __webpack_public_path__ + "img/benefit_3.10a39c76.svg";